class ID {

    static unique = () => {
         return 'unique()'
    }

    static custom = (id) => {
         return id
    }
}

module.exports = ID;
